import { apiSlice } from '../../app/api/apiSlice';

export interface PermitStatusData {

    workScheduleId: string;
    projectName: string;
    location: string;
    status: string;
    workDate: string;

}

export const permitStatusSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // 獲取進行中的許可證
        getOngoingPermits: builder.query<PermitStatusData[], void>({
            query: () => "/Dashboard/workPermit/ongoing",
            transformResponse: (response: any) => {
                // 根據實際 API 響應格式調整
                return response?.records || response || [];
            },
        }),

        // 獲取已過期的許可證
        getExpiredPermits: builder.query<PermitStatusData[], void>({
            query: () => "/Dashboard/workPermit/expired",
            transformResponse: (response: any) => {
                // 根據實際 API 響應格式調整
                return response?.records || response || [];
            },
        }),
    }),
});

export const {
    useGetOngoingPermitsQuery,
    useGetExpiredPermitsQuery,
} = permitStatusSlice;